const RECORDER_MIME_CANDIDATES = ["audio/webm;codecs=opus", "audio/webm", "audio/mp4"];

/** First recorder mime the browser supports. Safari lands on audio/mp4. */
export function pickRecorderMime(isTypeSupported: (mime: string) => boolean): string | null {
  return RECORDER_MIME_CANDIDATES.find((mime) => isTypeSupported(mime)) ?? null;
}
